<div class="position-relative">
    <div class="d-flex align-items-center gap-2 mb-4">
        <div class="flex-container justify-content-center p-2 cursor-pointer" (click)="goBack()">
            <img class="back-arrow" src="../../../assets/images/back_arrow.png" alt="" srcset="">
        </div>
        <h3 class="text-heading-3 text-start text-capitalize">{{currentType === 'edit' ? 'Edit Role' : 'Add New Role'}}</h3>
    </div>
    <div class="app-border-grey w-100">
        <form #f="ngForm" name="form" (ngSubmit)="f.form.valid && addOrEditRole(f.value)" novalidate>
            <div class="p-3">
                <div class="d-flex flex-column gap-2">
                    <label for="role-name" class="text-para text-light-dark">Role Name</label>
                    <input class="app-border-grey px-2 py-2 role-name text-capitalize" type="text" name="role_name" id="role-name" #role_name="ngModel" [(ngModel)]="role.name" required>
                    <div class="form-error-msg text-para">
                        <div *ngIf="f.submitted && role_name.errors?.required">Role name is required</div>
                    </div>
                </div>
                <div class="">
                    <h4 class="text-heading-4 text-dark">Set Permissions</h4>
                </div>
            </div>
            <div class="permissions-wrapper">
                <div class="accordion-btn cursor-pointer d-flex gap-3 align-items-center app-border-grey px-3 py-2 bg-blue-100" (click)="onTabClick($event, 'tab-web')">
                    <div class="d-flex justify-content-center align-items-center">
                        <img class="d-none accordion-collapse" src="../../../../assets/images/cabinet/accordion_collapse.svg" alt="collapse" srcset="">
                        <img class="accordion-expand" src="../../../../assets/images/cabinet/accordion_expanded.svg" alt="expand" srcset="">
                    </div> 
                    <h6 class="text-heading-6 text-light-dark">Web App Permissions</h6>
                </div>
                <div id="tab-web" class="tab-content current">
                    <div class="d-flex gap-5 permission-group-wrapper py-3" *ngFor="let permissionGroup of permissions.web.groups; index as i">
                        <div class="permission-group d-flex align-items-start justify-content-between">
                            <div class="text-para text-light-dark">{{ i+1 }}. {{ permissionGroup.name }}</div>
                            <div class="d-flex align-items-center">
                                <input type="checkbox" [name]="permissionGroup.name" [id]="permissionGroup.name" (change)="onGroupPermissionChecked($event, i, 'web')" [(ngModel)]="permissionGroup.isChecked"/>
                                <label [for]="permissionGroup.name"></label>
                                <span class="ms-3 text-para text-light-dark">{{ permissionGroup.isChecked ? 'Yes' : 'No' }}</span>
                            </div>
                        </div>
                        <div class="flex-grow-1 px-4">
                            <div class="d-flex align-items-start justify-content-between mb-3" *ngFor="let permission of permissionGroup.permissions">
                                <div class="text-para text-light-dark">{{ permission.name }}</div>
                                <div class="d-flex align-items-center">
                                    <input type="checkbox" [name]="permission.u_name" [(ngModel)]="permission.isChecked" [id]="permission.u_name" (change)="onPermissionChecked($event, i, 'web')"/>
                                    <label [for]="permission.u_name"></label>
                                    <span class="ms-3 text-para text-light-dark">{{ permission.isChecked ? 'Yes' : 'No' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="accordion-btn cursor-pointer d-flex gap-3 align-items-center app-border-grey px-3 py-2 bg-blue-100" (click)="onTabClick($event, 'tab-hardware')">
                    <div class="d-flex justify-content-center align-items-center">
                        <img class="accordion-collapse" src="../../../../assets/images/cabinet/accordion_collapse.svg" alt="collapse" srcset="">
                        <img class="d-none accordion-expand" src="../../../../assets/images/cabinet/accordion_expanded.svg" alt="expand" srcset="">
                    </div> 
                    <h6 class="text-heading-6 text-light-dark">Hardware Permissions</h6>
                </div>
                <div id="tab-hardware" class="tab-content">
                    <div class="d-flex gap-5 permission-group-wrapper py-3" *ngFor="let permissionGroup of permissions.hardware.groups; index as i">
                        <div class="permission-group d-flex align-items-start justify-content-between">
                            <div class="text-para text-light-dark">{{ i+1 }}. {{ permissionGroup.name }}</div>
                            <div class="d-flex align-items-center">
                                <input type="checkbox" [name]="permissionGroup.name" [id]="permissionGroup.name" (change)="onGroupPermissionChecked($event, i, 'hardware')" [(ngModel)]="permissionGroup.isChecked"/>
                                <label [for]="permissionGroup.name"></label>
                                <span class="ms-3 text-para text-light-dark">{{ permissionGroup.isChecked ? 'Yes' : 'No' }}</span>
                            </div>
                        </div>
                        <div class="flex-grow-1 px-4">
                            <div class="d-flex align-items-start justify-content-between mb-3" *ngFor="let permission of permissionGroup.permissions">
                                <div class="text-para text-light-dark">{{ permission.name }}</div>
                                <div class="d-flex align-items-center">
                                    <input type="checkbox" [name]="permission.u_name" [(ngModel)]="permission.isChecked" [id]="permission.u_name" (change)="onPermissionChecked($event, i, 'hardware')"/>
                                    <label [for]="permission.u_name"></label>
                                    <span class="ms-3 text-para text-light-dark">{{ permission.isChecked ? 'Yes' : 'No' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-btn-group p-3 d-flex align-items-center gap-3">
                <button class="primary-btn text-button" type="submit">{{currentType === 'edit' ? 'Edit Role' : 'Add Role'}}</button>
                <button class="primary-btn text-button" type="button" (click)="goBackWithConfirmation()">Cancel</button>
            </div>
        </form>
    </div>
    <app-toast-message></app-toast-message>
</div>
